/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { LazyloadService } from '@dm/core';
import { SWITCH } from 'app/config';

import { FileDnsServiceComponent } from '../../../../../../../settings/file-storage-service/file-dns-service/file-dns-service.component';
import { FileDnsServiceStrService } from '../../../../../../../settings/file-storage-service/file-dns-service/file-dns-service-str.service';

@Component({
    selector: 'app-configure-dns',
    templateUrl: './configure-dns.component.html',
    styleUrls: ['./configure-dns.component.scss'],
})
export class ConfigureDnsComponent implements OnInit {
    /**
     * 是否展示极简样式
     */
    @Input() simpleModeStyle = false;
    @Input() vstoreId: string;
    @Output() onClose = new EventEmitter<any>();
    @ViewChild('fds') fds: FileDnsServiceComponent;

    i18n = this.fileDnsStrService.i18n;

    pageReady = true;
    windowVisible = true;
    SWITCH = SWITCH;

    isSimpleMode: boolean;

    constructor(
        public fileDnsStrService: FileDnsServiceStrService,
        private lazyloadService: LazyloadService,
    ) {}

    ngOnInit(): void {
        this.isSimpleMode = SWITCH.IS_SIMPLE_MODE || this.simpleModeStyle;
    }

    operation(): void {
        this.windowVisible = false;
    }

    save(): void {
        if (!this.fds.vm.rowValueChanged && !this.fds.dnsVm.rowValueChanged && !this.fds.hasDnsRemove) {
            this.windowVisible = false;
            return;
        }
        this.fds.onSave();
    }

    onHide(): void {
        this.onClose.emit();
        this.lazyloadService.destroySelf(this);
    }
}
